/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IProcedureEpisode } from 'app/shared/model/procedure-episode.model';
import { ProcedureOutcome } from 'app/shared/model/enumerations/procedure-outcome.model';
import { ProcedureStatus } from 'app/shared/model/enumerations/procedure-status.model';
import { ProcedureStatusReason } from 'app/shared/model/enumerations/procedure-status-reason.model';

export interface IPatientProcedureEpisode {
  id?: string;
  plannedStart?: number | null;
  plannedEnd?: number | null;
  actualStart?: number | null;
  actualEnd?: number | null;
  outcome?: keyof typeof ProcedureOutcome | null;
  notes?: string;
  status?: keyof typeof ProcedureStatus | null;
  statusReason?: keyof typeof ProcedureStatusReason | null;
  active?: boolean | null;
  cursor?: number;
  lastUpdated?: number | null;
  microSec?: number;
  timestampEntry?: number;
  procedure?: IPatientProcedure | null;
  metaEpisode?: IProcedureEpisode | null;
}

export const defaultValue: Readonly<IPatientProcedureEpisode> = {
  active: false,
};
